import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';

import { AccountInformationService } from '../../../core/api/services';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'account-information-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class AccountInformationSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  @Input('organizationId') input_organizationId: number;

  constructor(
    protected currentService: AccountInformationService,
    public translate: TranslateService
  ) {
    super();
  }

  initConfig() {
    this.optionValue = 'id';
    this.optionTitle = 'optionTitle';
    if (!this.label) this.label = 'common.accountInformation';
  }

  getItemsApi() {
    this.currentService
      .accountInformationGetAccountInformationsList(
        this.input_organizationId
          ? { OrganizationId: this.input_organizationId }
          : {}
      )
      .pipe(
        this.basePipeOperators(),
        map((items) => {
          return items.data.map((item) => {
            let translatedTypeBank = this.translate.instant(
              `enums.TypeBanks.${item.typeBank}`
            );
            return {
              ...item,
              optionTitle: `${item.accountNo} ${translatedTypeBank} (${item.owner})`,
            };
          });
        })
      )
      .subscribe(this.baseObserver);
  }
}
